import { useMutation } from "@tanstack/react-query";
import { verifyDomainAvailability } from "../api";
import type { VerifyDomainAvailabilityResponse } from "../types";
import type { ApiResponse } from "~/lib/react-query/types";

interface UseVerifyDomainsOptions {
  onSuccess?: (data: ApiResponse<VerifyDomainAvailabilityResponse>) => void;
  onError?: (error: Error) => void;
}

/**
 * React Query hook for verifying domain availability
 * Used as a mutation for on-demand domain checks
 */
export function useVerifyDomains(options?: UseVerifyDomainsOptions) {
  return useMutation({
    mutationFn: (domains: string[]) => verifyDomainAvailability(domains),
    onSuccess: (data) => {
      if (data.success && options?.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error: Error) => {
      if (options?.onError) {
        options.onError(error);
      }
    },
  });
}
